import template from './photo-uploader.template.html';
import {PhotoUploaderController} from './photo-uploader.controller';

export class PhotoUploaderService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;
    }

    open() {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: PhotoUploaderController,
            controllerAs: '$ctrl'
        });

        return modalInstance
            .result
            .then(function (result) {
                return result;
            });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/photo-uploader/photo-uploader.service.js